import { useQuery } from "@tanstack/react-query";
import { fetchFloorPlanMemoTexts } from "~/_legacy/apis/fetch-floor-plan-memo-texts";

export const FLOOR_PLAN_MEMO_TEXTS_GROUPED_BY_FLOOR_PLAN_QUERY_KEY =
  "floorPlanMemoTextsGroupedByFloorPlan";

export function useGetFloorPlanMemoTextsGroupedByFloorPlan({
  branchUid,
  branchVersionId,
  floorPlanIds,
}: {
  branchUid?: string;
  branchVersionId?: number;
  floorPlanIds: number[];
}) {
  return useQuery({
    queryKey: [
      FLOOR_PLAN_MEMO_TEXTS_GROUPED_BY_FLOOR_PLAN_QUERY_KEY,
      branchUid,
      branchVersionId,
      floorPlanIds,
    ],
    queryFn: async () => {
      const entries = await Promise.all(
        floorPlanIds.map(async (floorPlanId) => [
          floorPlanId,
          await fetchFloorPlanMemoTexts({ branchUid: branchUid!, branchVersionId, floorPlanId }),
        ])
      );
      return Object.fromEntries(entries);
    },
    enabled: Boolean(branchUid && floorPlanIds.length > 0),
  });
}
